export const parseSetPlayerLimitError = (error = {}, defaultMessage) => {
    const { errorMessage, userErrors } = error;

    return userErrors?.[0]?.message || errorMessage || defaultMessage;
};
